import React from "react";

const PaymentFailure = () => {
  return (
    <div className="text-center p-5">
      <h3>Payment Failed</h3>
      <p>There was an issue processing your payment. Please try again.</p>
    </div>
  );
};

export default PaymentFailure;